import {Button} from '@shipwell/shipwell-ui';
import {FlexBox} from 'App/components/Box';

export const AddOrdersToShipmentFooter = ({
  onClose,
  isModifyingOrders,
  isAddingOrdersToShipment,
  selectedOrderIds,
  setIsModifyingOrders,
  handleAddOrdersToShipment
}: {
  onClose: () => void;
  isModifyingOrders: boolean;
  isAddingOrdersToShipment: boolean;
  selectedOrderIds: string[];
  setIsModifyingOrders: (arg0: boolean) => void;
  handleAddOrdersToShipment: () => void;
}) => (
  <FlexBox gap="m" justify="end">
    <Button onClick={onClose} variant="secondary">
      Cancel
    </Button>
    {!isModifyingOrders ? (
      <Button
        variant="primary"
        isLoading={isAddingOrdersToShipment}
        disabled={!selectedOrderIds.length}
        onClick={() => setIsModifyingOrders(true)}
      >
        Modify Orders
      </Button>
    ) : null}
    <Button
      variant="primary"
      isLoading={isAddingOrdersToShipment}
      disabled={!selectedOrderIds.length}
      onClick={() => handleAddOrdersToShipment()}
    >
      Add to Shipment
    </Button>
  </FlexBox>
);
